var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21.2175H19.395C18.495 21.2175 17.64 21.5662 17.01 22.1962L15.0862 24.0975C14.2087 24.9637 12.78 24.9637 11.9025 24.0975L9.97875 22.1962C9.34875 21.5662 8.4825 21.2175 7.59375 21.2175H6.75C4.8825 21.2175 3.375 19.7212 3.375 17.8762V5.60248C3.375 3.75748 4.8825 2.26123 6.75 2.26123H20.25C22.1175 2.26123 23.625 3.75748 23.625 5.60248V17.8762C23.625 19.71 22.1175 21.2175 20.25 21.2175Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.6173C18 15.5923 15.9863 13.9498 13.5 13.9498C11.0137 13.9498 9 15.5923 9 17.6173M13.5 11.2498C13.8442 11.2498 14.1851 11.182 14.5031 11.0503C14.8211 10.9186 15.1101 10.7255 15.3535 10.4821C15.5969 10.2387 15.79 9.94971 15.9217 9.63168C16.0534 9.31366 16.1212 8.9728 16.1212 8.62857C16.1212 8.28435 16.0534 7.94349 15.9217 7.62546C15.79 7.30744 15.5969 7.01848 15.3535 6.77507C15.1101 6.53167 14.8211 6.33858 14.5031 6.20685C14.1851 6.07512 13.8442 6.00732 13.5 6.00732C12.8048 6.00732 12.1381 6.28349 11.6465 6.77507C11.1549 7.26665 10.8788 7.93338 10.8788 8.62857C10.8788 9.32377 11.1549 9.9905 11.6465 10.4821C12.1381 10.9737 12.8048 11.2498 13.5 11.2498Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.79e8092fc6c455ad5c5cc32171e642c3.svg";
export { ForwardRef as ReactComponent };